<template>
<div class="xin">
    <!-- tab 切换  -->
    <div class="switch">
        <el-tabs>
            <!-- 管理系统服务 -->
            <el-tab-pane label>
                <span slot="label">
                    {{ $t("logs.system1") }}
                </span>
                <div class="main" v-if="this.has_min==1">
                    <p>
                        <el-select v-model="salt_minion_ip_service" placeholder="" @change="change_system">
                            <el-option v-for="item in salt_minion_ip_service_arr" :key="item.value" :label="item.label" :value="item.value">
                            </el-option>
                        </el-select>
                    </p>
                </div>
                <div class="switch1">
                    <div class="table">
                        <el-table ref="multipleTable" tooltip-effect="dark" style="width: 100%" :data="fileList" v-loading="loading" :cell-class-name="tableCellClassName">
                            <el-table-column prop="name" :label="$t('logs.system2')"></el-table-column>
                            <el-table-column prop="run_hint" :label="$t('logs.system3')"></el-table-column>

                            <el-table-column prop="address" :label="$t('logs.audit6')">
                                <template slot-scope="scope">
                                    <!-- 停止-->
                                    <el-button @click="switch_service1(scope.$index, scope.row)" type="text" size="small" v-if="scope.row.is_run==1"  :disabled="$root.jurisdiction.only_query==0"> {{stop_hint}}</el-button>
                                    <!-- 启动-->
                                    <el-button @click="switch_service2(scope.$index, scope.row)" type="text" size="small" v-if="scope.row.is_run==0" style="color:#F00"  :disabled="$root.jurisdiction.only_query==0"> {{start_hint }}</el-button>
                                    <!-- 启动-->
                                    <el-button @click="switch_service3(scope.$index, scope.row)" type="text" size="small"  :disabled="$root.jurisdiction.only_query==0"> {{restart_hint }}</el-button>
                                </template>

                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="pop-up" v-show="tanchu">
                        <div class="find">
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">策略用户:</div>
                                <div class="block block1">
                                    <el-input v-model="input" placeholder></el-input>
                                </div>
                            </div>
                        </div>

                        <el-row>
                            <el-button type="primary" @click="tanSend()">保存</el-button>
                            <el-button type="primary" @click="tanOff()">取消</el-button>
                        </el-row>
                    </div>
                    <div class="gray" v-show="tanchu"></div>
                </div>
            </el-tab-pane>
        </el-tabs>
    </div>
</div>
</template>

<script>
// import $ from "jquery";
export default {
    data() {
        return {
            stop_hint: '',
            start_hint: '',
            restart_hint: '',
            salt_minion_ip_service: '127.0.0.1',
            salt_minion_ip_service_arr: [],
            has_min: '',
            is_run: '',
            textarea: "",
            input: "",
            time: new Date(2020, 9, 10, 18, 40),
            value1: "",

            tableData: [{
                address: "44"
            }],
            emali: "",
            value: "",
            checkList: [],
            tanchu: false,
            options: [{
                    value: "选项1",
                    label: "不使用TLS"
                },
                {
                    value: "选项2",
                    label: "增加信头标记"
                },
                {
                    value: "选项3",
                    label: "强制TLS"
                }
            ],
            checked: "",
            fileList: [],
            radio: [],
            loading: false,
            action: '',
            server: '',
        };
    },
    mounted() {
        this.getFileList1()
    },
    methods: {
        // 判断状态变色
        tableCellClassName({
            row,

        }) {
            // console.log(row, rowIndex);

            if (row.is_run == 1) {
                return "sent1";
            } else if (row.is_run == 0) {
                return "sent2";
            }
            return "";
        },
        change_system(a) {
            this.salt_minion_ip_service = a
            this.getFileList1()
        },
        // 显示
        tan: function () {
            this.tanchu = true;
        },
        // 打开关闭
        tanSend: function () {
            this.tanchu = false;
        },
        tanOff: function () {
            this.tanchu = false;
        },
        switch_service1(index, scope) {
            console.log(index, scope)

            this.action = 'stop'
            this.server = scope.server
            this.handleClick1()
        },
        switch_service2(index, scope) {
            this.action = 'start'
            this.server = scope.server

            this.handleClick1()
        },
        switch_service3(index, scope) {
            this.action = 'restart'
            this.server = scope.server

            this.handleClick1()
        },
        //系统服务操作
        handleClick1() {

            this.loading = true

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

            let str = this.$qs.stringify({
                __mode: "switch_service",
                sid: sid,
                salt_minion_ip: this.salt_minion_ip_service,
                server: this.server,
                action: this.action,

            });
            // console.log(str)
            this.$axios
                .post("/api/adm/cgi/newspam.cgi", str)
                .then((res) => {
                    // console.log(res);

                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        // this.getFileList();
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.loading = false;
                        this.getFileList1();
                        // this.$message({
                        //     type: "success",
                        //     message: `${this.$t('anti_gs1_tan.del1')}`,
                        // });
                    }
                });

        },
        // 管理系统服务加载
        getFileList1() {
            this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "list_service",
                        sid: sid,
                        salt_minion_ip: this.salt_minion_ip_service
                    },
                })
                .then((res) => {
                    console.log(res);

                    if(!res){
             this.loading = false;
          }
         else if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        this.loading=false
                        // this.getFileList3();
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.loading = false;
                        if (res.data.ret.HAS_MINION) {
                            this.has_min = 1
                        }

                        this.fileList = res.data.ret.datalist;
                        this.restart_hint = res.data.ret.restart_hint;
                        this.start_hint = res.data.ret.start_hint;
                        this.stop_hint = res.data.ret.stop_hint;
                        this.is_run = res.data.ret.is_run
                        this.salt_minion_ip_service_arr = res.data.ret.q_minion_host

                        // 

                    }
                })
               
        },
    }
};
</script>

<style lang="less" scoped>
// input 框高度

// /deep/ .el-tabs__header {
//     margin: 0;
// }

// /deep/ .el-alert__content {
//     padding: 0;
// }

/deep/ .el-input--suffix {
    width: 222px;
}

/deep/ .el-select {
    // padding-left: 30px;
    width: 222px;
    margin: 4px 0;
}

// 1
.main {
    display: flex;
    align-items: center;
    // border: 1px solid #dcdfe6;
    // background: #f1f1f1;
    margin-bottom: 20px;
    box-sizing: border-box;
    text-align: left;
    margin: 020px;
    //   margin-top: 20px;
}

.main p {
    padding-left: 10px;
    font-size: 14px;
    line-height: 28px;
}

// .main span {
//     padding-left: 20px;
// }

.el-button {
    padding: 6px;
}

.find2-1 .find-text {
    font-size: 14px;
}

.find2-1 .el-row {
    margin-left: 140px;
}

// input 框高度
/deep/ .el-input__inner {
    height: 26px;
}

// 弹出框1

// button  按钮
/deep/ .el-button {
    padding: 6px 10px;
    margin-left: 10px;
    margin: 5px 20px;
}

// input 框高度
/deep/ .el-input__inner {
    height: 30px;
}

.el-checkbox-group {
    display: flex;
}

.table span {
    font-size: 14px;
}

// th  改高度
/deep/ .el-table th {
    padding: 4px 0;
}

// td  改高度
/deep/ .el-table td {
    padding: 4px 0;
}

/deep/ .cell {
    text-align: center;
}

// 时间
.time {
    display: flex;
    flex-direction: column;
    border: 1px solid #dcdfe6;
    background: #f1f1f1;
    margin: 10px 0;
}

.time1 {
    display: flex;
    align-items: center;
    padding: 2px 0 2px 14px;
    font-size: 14px;
}

// 手动设置
.time-text1 {
    padding-left: 20px;
}

// 后台管理控制
.back {
    display: flex;
    font-size: 14px;
    line-height: 30px;
    align-items: center;
    padding: 6px 0;
}

// .back div {
//   margin: 0 10px;
// }
.back .el-input {
    margin: 0 10px;
}

.backText {
    text-align: right;
}

.backText1 {
    color: #999;
    font-size: 12px;
}

.back .el-input {
    width: 20%;
    padding: 0;
}

.time2 {
    display: flex;
    margin-left: 190px;
    margin-top: 10px;
}

.time2 .el-button {
    padding: 8px 24px;
    // margin: 10px ;
}

// License
.time3 {
    display: flex;
    align-items: center;
    // margin-left: 150px;
    font-size: 14px;
    padding: 4px 10px;
}

// selece
.selece1 {
    width: 130px;
}

// input 框
.back1 .input1 {
    width: 100px;
    margin: 0 10px;
}

// 单选框
.check1 {
    margin: 0 10px;
}

.backText2 {
    margin-left: 40px;
}

.backText3 {
    margin-left: 30px;
}

.back1 .input5-1 {
    width: 100px;
}

/deep/.el-input__icon {
    line-height: 30px;
    height: 30px;
}

// /deep/ .el-tabs__item.is-active {
//     //   color: #409eff;
//     background: #fff;
// }

// /deep/ .el-tabs__active-bar {
//     height: 0;
// }

// 弹框下的复选框
.el-checkbox:last-of-type {
    margin-right: 10px;
}

@import "../../css/table.less";

@import "../../css/lie_td.less";
@import "../../css/pou_up.less";

/deep/ .el-tabs__nav {
    padding-left: 16px;
}

/deep/ .sent2 .cell {
    color: #f00 !important;
}
</style>
